import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { getBayphoneUserTableDefinitions, bayphoneUserQueries } from './BayphoneUserTableDefinitions'

class BayphoneUserMinimalTableTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "BayphoneUserMinimalTableTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, bayphoneUserQueries)

        tableCreator.setDescriptions(
            getBayphoneUserTableDefinitions(true)
        )

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(BayphoneUserMinimalTableTableCreator)

export default BayphoneUserMinimalTableTableCreator
